import script from "./PostDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PostDetails.vue?vue&type=script&setup=true&lang=js"

import "./PostDetails.vue?vue&type=style&index=0&id=4bd1ba14&lang=css"

const __exports__ = script;

export default __exports__